import React from 'react';
import DashboardPage from '@/modules/dashboard/pages/DashboardPage';
import { useUser } from '@dofleini/security';

const HomePageGate = () => {
  const { hasPermission, user } = useUser();
  return <DashboardPage userId={!hasPermission('ADMIN') ? user?._id : null} />;
};

export default HomePageGate;

